import { render } from "./CoordinateUpload.vue?vue&type=template&id=65ca3e29"
import script from "./CoordinateUpload.vue?vue&type=script&lang=js"
export * from "./CoordinateUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__